<template>
  <Card :padding="false">
    <template slot="header">Parking Areas</template>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="dialog=true"
    >
      Create
    </v-btn>
    <Modal
      :visible="dialog"
      :ok-visible="true"
      :cancel-visible="true"
      ok-text="Save"
      title="Create"
      @ok="save"
      @cancel="close"
    >
      <v-layout column>
        <!-- identification -->
        <v-text-field
          v-model="editedItem.parkingName"
          label="Name"
        />
        <v-text-field
          v-model="editedItem.parkingCapacity"
          label="Capacity"
        />
        <!-- dates -->
        <v-menu
          :nudge-right="30"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="editedItem.openDate"
            label="Open Date"
            prepend-icon="event"
            readonly
          />
          <v-date-picker v-model="editedItem.openDate"/>
        </v-menu>
        <v-menu
          :nudge-right="30"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="editedItem.closeDate"
            label="Close Date"
            prepend-icon="event"
            readonly
          />
          <v-date-picker v-model="editedItem.closeDate"/>
        </v-menu>
      </v-layout>
    </Modal>
    <v-data-table
      :headers="headers"
      :items="parkingAreas"
      hide-actions
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>
          {{ props.item.parkingName }}
        </td>
        <td>
          {{ props.item.parkingCapacity }}
        </td>
        <td>
          {{ props.item.openDate.slice(5) }}<br>
          {{ props.item.closeDate.slice(5) }}
        </td>
        <td class="text-xs-right">
          <IconButton
            :to="{path: '/parkingAreas/blackouts', query: props.item}"
            icon="fa-calendar-times"
            tooltip="Blackouts"
          />
          <IconButton
            icon="fa-edit"
            tooltip="Edit"
            @click="editItem(props.index)"
          />
          <IconButton
            icon="fa-times"
            color="red"
            tooltip="Delete"
            @click="deleteItem(props.index)"
          />
        </td>
      </template>
    </v-data-table>
  </Card>
</template>

<script>
// import vuex mapping
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    personGroup: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      campgroundID: this.$route.query.campgroundID,
      dialog: false,
      headers: [
        {
          text: 'Parking Area',
          sortable: false
        },
        {
          text: 'Capacity',
          sortable: false
        },
        {
          text: 'Open',
          sortable: false
        },
        {
          text: '',
          align: 'right',
          sortable: false
        }
      ],
      editedIndex: -1,
      editedItem: {}
    }
  },
  computed: {
    ...mapGetters({
      parkingAreas: 'facilities/parkingAreas'
    })
  },
  mounted () {
    this.getParkingAreas()
  },
  methods: {
    ...mapActions({
      getParkingAreas: 'facilities/getParkingAreas',
      createParkingArea: 'facilities/createParkingArea',
      deleteParkingArea: 'facilities/deleteParkingArea',
      updateParkingArea: 'facilities/updateParkingArea'
    }),
    editItem (index) {
      this.editedIndex = index
      this.editedItem = this.parkingAreas[index]
      this.dialog = true
    },
    deleteItem (index) {
      let confirmation = confirm('Are you sure you want to delete this parking area?')
      if (confirmation) {
        this.deleteParkingArea({ parkingAreaID: this.parkingAreas[index].parkingAreaID })
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex === -1) {
        this.createParkingArea(this.editedItem)
      } else {
        this.updateParkingArea(this.editedItem)
      }
      this.close()
    }
  }
}
</script>
